import boxShadows from "../base/boxShadows";
import colors from "../base/colors";



const { transparent,primary } = colors;

export default {
  styleOverrides: {
    root: {
      boxShadow:  boxShadows.lg,
    
      "&:hover": {
        boxShadow:  boxShadows.lg,
        backgroundColor: transparent.main,
        
      },
    },
  },
};
